import { Box, styled } from '@mui/material';

import useIsMobileSize from 'src/hooks/useIsMobileSize';
import Filters from 'src/widgets/FeedFilter/Desktop';
import MenuComponent from 'src/widgets/Menu/Menu';

interface IDesktopLayoutProps {
    children: React.ReactNode;
    hideRightSidebar?: boolean;
    withMainContentWrapper?: boolean;
    rightSidebar?: React.ReactNode;
}

const RightSidebarContainer = styled(Box)(() => ({
    height: '100vh',
    overflow: 'auto',
    position: 'sticky',
    top: 0,
    '&::-webkit-scrollbar': {
        width: '6px',
    },
    '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
        borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb': {
        background: '#c1c1c1',
        borderRadius: '3px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
        background: '#a8a8a8',
    },
}));

export default function DesktopLayout({
    children,
    hideRightSidebar = false,
    withMainContentWrapper,
    rightSidebar,
}: IDesktopLayoutProps) {
    const isMobile = useIsMobileSize();

    if (isMobile) return <>{children}</>;

    return (
        <Box
            display="grid"
            gridTemplateColumns={hideRightSidebar ? '300px minmax(400px,1fr)' : '300px minmax(400px,1fr) 330px'}
            bgcolor="#EFF3F7"
            minHeight="100%"
            maxWidth={1920}
            margin="auto"
        >
            <MenuComponent
                open={true}
                anchore="left"
                variant="permanent"
                onClose={() => {}}
            />

            <Box
                px={7}
                py={5}
            >
                {withMainContentWrapper ? <MainContentWrapper>{children}</MainContentWrapper> : children}
            </Box>
            {!hideRightSidebar && (
                <RightSidebarContainer>{rightSidebar ? rightSidebar : <Filters />}</RightSidebarContainer>
            )}
        </Box>
    );
}

interface IMainContentWrapperProps {
    children: React.ReactNode;
}

const Wrapper = styled(Box)(({ theme }) => ({
    padding: '1rem',
    background: theme.palette.background.default,
    height: '100%',
}));

export const MainContentWrapper = ({ children }: IMainContentWrapperProps) => {
    return <Wrapper>{children}</Wrapper>;
};
